<!-- ============================================================
     LIBRARY MANAGEMENT — Catalog · Issue/Return · Records · Members
     ============================================================ -->
<div class="lib-page">

  <!-- Toast -->
  @if (saveSuccess()) {
    <div class="lib-toast alert alert-success d-flex align-items-center gap-2 shadow">
      <i class="bi bi-check-circle-fill fs-5"></i><strong>{{ saveSuccess() }}</strong>
    </div>
  }

  <!-- Delete Modal -->
  @if (showDeleteModal()) {
    <div class="lib-overlay" (click)="showDeleteModal.set(false)">
      <div class="lib-modal lib-modal-sm" (click)="$event.stopPropagation()">
        <div class="lmh del-hdr"><div class="lmh-icon"><i class="bi bi-trash3-fill"></i></div>
          <div><h5 class="lmh-title">Delete?</h5><p class="lmh-sub">{{ deleteCtx()?.label }}</p></div>
          <button class="lmh-close" (click)="showDeleteModal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="lmb p-4 text-center"><p class="text-muted small mb-0">This action cannot be undone.</p></div>
        <div class="lmf"><button class="btn btn-outline-secondary px-4" (click)="showDeleteModal.set(false)">Cancel</button>
          <button class="btn btn-danger px-4" (click)="executeDelete()"><i class="bi bi-trash3 me-2"></i>Delete</button></div>
      </div>
    </div>
  }

  <!-- ===================== PAGE HEADER ===================== -->
  <div class="lib-ph mb-4">
    <div>
      <h1 class="lib-title"><i class="bi bi-journals me-2 text-primary" style="font-size:1.1rem;"></i>Library Management</h1>
      <p class="lib-subtitle">Catalog · Issue/Return · Records · Members</p>
    </div>
    <div class="d-flex gap-2 flex-wrap">
      @if (overdueIssues().length > 0) {
        <div class="overdue-chip"><i class="bi bi-exclamation-triangle-fill me-1"></i>{{ overdueIssues().length }} overdue</div>
      }
      @if (activeTab() === 'catalog' && bookMode() === 'list') {
        <button class="btn lib-btn-primary btn-sm" (click)="openNewBook()"><i class="bi bi-plus-circle-fill me-1"></i>Add Book</button>
      }
      @if (activeTab() === 'members' && memberMode() === 'list') {
        <button class="btn lib-btn-primary btn-sm" (click)="openNewMember()"><i class="bi bi-plus-circle-fill me-1"></i>Add Member</button>
      }
      @if ((activeTab() === 'catalog' && bookMode() !== 'list') || (activeTab() === 'members' && memberMode() !== 'list')) {
        <button class="btn btn-outline-secondary btn-sm" (click)="bookMode.set('list'); memberMode.set('list')">
          <i class="bi bi-arrow-left me-1"></i>Back
        </button>
      }
    </div>
  </div>

  <!-- Stats Row -->
  <div class="lib-stats-row mb-4">
    <div class="lsr-item">
      <!-- <div class="lsr-icon" style="background:linear-gradient(135deg,#1a3a6b,#2d6a9f)">
        <i class="bi bi-book-fill"></i>
      </div> -->
      <div class="d-flex flex-column">
        <div class="lsr-val"><i class="bi bi-book"></i> {{ libStats().totalBooks }}</div>
        <div class="lsr-label">Total Books</div>
      </div>
    </div>
    <div class="lsr-item">
      <!-- <div class="lsr-icon" style="background:linear-gradient(135deg,#059669,#10b981)">
        <i class="bi bi-check-circle-fill"></i>
      </div> -->
      <div class="d-flex flex-column">
        <div class="lsr-val text-success"><i class="bi bi-check-circle"></i> {{ libStats().available }}</div>
        <div class="lsr-label">Available</div>
      </div>
    </div>
    <div class="lsr-item">
      <!-- <div class="lsr-icon" style="background:linear-gradient(135deg,#d97706,#f59e0b)">
        <i class="bi bi-arrow-up-right-circle-fill"></i>
      </div> -->
      <div class="d-flex flex-column">
        <div class="lsr-val text-warning"><i class="bi bi-arrow-up-right-circle"></i> {{ libStats().issued }}</div>
        <div class="lsr-label">Issued</div>
      </div>
    </div>
    <div class="lsr-item" [class.stat-alert]="libStats().overdue > 0">
      <!-- <div class="lsr-icon" [style.background]="libStats().overdue > 0 ? 'linear-gradient(135deg,#dc2626,#ef4444)' : 'linear-gradient(135deg,#6b7280,#9ca3af)'">
        <i class="bi bi-clock-fill"></i>
      </div> -->
      <div class="d-flex flex-column">
        <div class="lsr-val" [class.text-danger]="libStats().overdue > 0">
          <i class="bi bi-clock"></i> {{ libStats().overdue }}</div>
        <div class="lsr-label">Overdue</div>
      </div>
    </div>
    <div class="lsr-item">
      <!-- <div class="lsr-icon" style="background:linear-gradient(135deg,#7c3aed,#a78bfa)">
        <i class="bi bi-people-fill"></i>
      </div> -->
      <div class="d-flex flex-column">
        <div class="lsr-val text-purple"><i class="bi bi-people"></i> {{ libStats().members }}</div>
        <div class="lsr-label">Members</div>
      </div>
    </div>
    <div class="lsr-item">
      <!-- <div class="lsr-icon" style="background:linear-gradient(135deg,#0d9488,#2dd4bf)">
        <i class="bi bi-cash-coin"></i>
      </div> -->
      <div class="d-flex flex-column">
        <div class="lsr-val text-teal"><i class="bi bi-cash-coin"></i> {{ formatCurrency(libStats().fineCollected) }}</div>
        <div class="lsr-label">Fine Collected</div>
      </div>
    </div>
    <div class="lsr-item" [class.stat-alert]="libStats().finePending > 0">
      <!-- <div class="lsr-icon" [style.background]="libStats().finePending > 0 ? 'linear-gradient(135deg,#be185d,#ec4899)' : 'linear-gradient(135deg,#6b7280,#9ca3af)'">
        <i class="bi bi-exclamation-diamond-fill"></i>
      </div> -->
      <div class="d-flex flex-column">
        <div class="lsr-val" [class.text-pink]="libStats().finePending > 0">
          <i class="bi bi-exclamation-diamond"></i> {{ formatCurrency(libStats().finePending) }}</div>
        <div class="lsr-label">Fine Pending</div>
      </div>
    </div>
  </div>

  <!-- TABS -->
  <div class="lib-tabs mb-4">
    @for (t of [{k:'catalog',l:'Book Catalog',ic:'bi-book-fill'},{k:'issue',l:'Issue / Return',ic:'bi-arrow-left-right'},{k:'records',l:'Records',ic:'bi-table'},{k:'members',l:'Members',ic:'bi-people-fill'}]; track t.k) {
      <button class="ltab" [class.active]="activeTab() === t.k"
        (click)="activeTab.set($any(t.k)); bookMode.set('list'); memberMode.set('list')">
        <i class="bi {{ t.ic }} me-1"></i>{{ t.l }}
      </button>
    }
  </div>

  <!-- ===================== BOOK CATALOG ===================== -->
  @if (activeTab() === 'catalog') {

    @if (bookMode() === 'list') {
      <!-- Filters -->
      <div class="lib-card mb-3"><div class="lc-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-5"><label class="form-label small fw-semibold text-muted">Search</label>
            <div class="input-group"><span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
              <input class="form-control border-start-0" placeholder="Title, author, accession no., ISBN…" [(ngModel)]="bookSearch">
              @if (bookSearch) { <button class="btn btn-outline-secondary" (click)="bookSearch=''"><i class="bi bi-x"></i></button> }
            </div></div>
          <div class="col-md-3"><label class="form-label small fw-semibold text-muted">Category</label>
            <select class="form-select" [(ngModel)]="bookCategory">
              <option value="">All Categories</option>
              @for (c of categories; track c) { <option [value]="c">{{ c }}</option> }
            </select></div>
          <div class="col-md-2"><label class="form-label small fw-semibold text-muted">Status</label>
            <select class="form-select" [(ngModel)]="bookStatus">
              <option value="">All</option>
              @for (s of ['Available','Issued','Reserved','Lost','Damaged']; track s) { <option [value]="s">{{ s }}</option> }
            </select></div>
          <div class="col-auto"><button class="btn btn-outline-secondary" (click)="bookSearch='';bookCategory='';bookStatus=''"><i class="bi bi-arrow-counterclockwise me-1"></i>Reset</button></div>
        </div>
        <small class="text-muted mt-2 d-block">{{ filteredBooks().length }} books found</small>
      </div></div>

      <!-- Book Grid -->
      @if (filteredBooks().length === 0) {
        <div class="empty-state"><i class="bi bi-book"></i><p>No books found</p></div>
      } @else {
        <div class="books-grid">
          @for (b of filteredBooks(); track b.id) {
            <div class="book-card" (click)="viewBook(b)">
              <!-- <div class="bc-cover" [style.background]="'linear-gradient(135deg,' + getCategoryColor(b.category) + ',' + getCategoryColor(b.category) + '88)'">
                <i class="bi bi-book-fill bc-icon"></i>
                <div class="bc-accession">{{ b.accession_no }}</div>
              </div> -->
              <div class="bc-body">
                <div class="bc-category" [style.color]="getCategoryColor(b.category)">{{ b.category }}</div>
                <h6 class="bc-title"><i class="bi bi-book"></i>&nbsp; {{ b.title }}</h6>
                <div class="bc-author">{{ b.author }}</div>
                <div class="bc-meta">{{ b.publisher }} · {{ b.publication_year }}</div>
                <!-- <div class="bc-availability">
                  <div class="ba-bar">
                    <div class="ba-fill" [style.width.%]="b.copies_total ? (b.copies_available/b.copies_total)*100 : 0" [style.background]="b.copies_available > 0 ? '#22c55e' : '#ef4444'"></div>
                  </div>
                  <span class="ba-text" [class.text-success]="b.copies_available > 0" [class.text-danger]="b.copies_available === 0">
                    {{ b.copies_available }}/{{ b.copies_total }} available
                  </span>
                </div> -->
                <div class="d-flex align-items-center justify-content-between mt-2">
                  <span class="{{ getBookStatusClass(b.status) }}">{{ b.copies_available }}/{{ b.copies_total }} - {{ b.status }}</span>
                  @if (b.price) { <span class="bc-price">{{ formatCurrency(b.price) }}</span> }
                </div>
              </div>
              <!-- <div class="bc-footer">
                <button class="bcf-btn edit" (click)="$event.stopPropagation(); editBook(b)"><i class="bi bi-pencil-fill me-1"></i>Edit</button>
                <button class="bcf-btn delete" (click)="$event.stopPropagation(); confirmDelete('book',b.id,b.title)"><i class="bi bi-trash3-fill"></i></button>
              </div> -->
            </div>
          }
        </div>
      }
    }

    @if (bookMode() === 'form') {
      <div class="lib-card">
        <div class="lc-header"><i class="bi bi-book-fill me-2"></i>{{ editingBookId() !== null ? 'Edit Book' : 'Add Book to Catalog' }}</div>
        <div class="lc-body">
          <div class="row g-3">
            <div class="col-md-3"><label class="form-label fw-semibold">Accession No. <span class="req">*</span></label>
              <input class="form-control text-uppercase" [(ngModel)]="bookForm.accession_no" placeholder="LIB-001" [class.is-invalid]="bookSubmitted && !bookForm.accession_no"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">ISBN</label>
              <input class="form-control" [(ngModel)]="bookForm.isbn" placeholder="978-…"></div>
            <div class="col-md-6"><label class="form-label fw-semibold">Title <span class="req">*</span></label>
              <input class="form-control" [(ngModel)]="bookForm.title" placeholder="Full book title" [class.is-invalid]="bookSubmitted && !bookForm.title"></div>
            <div class="col-md-5"><label class="form-label fw-semibold">Author(s) <span class="req">*</span></label>
              <input class="form-control" [(ngModel)]="bookForm.author" placeholder="Author name(s)" [class.is-invalid]="bookSubmitted && !bookForm.author"></div>
            <div class="col-md-5"><label class="form-label fw-semibold">Publisher</label>
              <input class="form-control" [(ngModel)]="bookForm.publisher" placeholder="Publisher name"></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Year</label>
              <input type="number" class="form-control" [(ngModel)]="bookForm.publication_year" min="1800" max="2030"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Edition</label>
              <input class="form-control" [(ngModel)]="bookForm.edition" placeholder="e.g. 3rd"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Category</label>
              <select class="form-select" [(ngModel)]="bookForm.category">
                @for (c of categories; track c) { <option [value]="c">{{ c }}</option> }
              </select></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Subject</label>
              <input class="form-control" [(ngModel)]="bookForm.subject" placeholder="e.g. Physics"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Language</label>
              <select class="form-select" [(ngModel)]="bookForm.language">
                @for (l of languages; track l) { <option [value]="l">{{ l }}</option> }
              </select></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Pages</label>
              <input type="number" class="form-control" [(ngModel)]="bookForm.pages" min="1"></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Price (₹)</label>
              <input type="number" class="form-control" [(ngModel)]="bookForm.price" min="0"></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Total Copies</label>
              <input type="number" class="form-control" [(ngModel)]="bookForm.copies_total" min="1"></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Available</label>
              <input type="number" class="form-control" [(ngModel)]="bookForm.copies_available" min="0"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Shelf Location</label>
              <input class="form-control" [(ngModel)]="bookForm.shelf_location" placeholder="e.g. A-01"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Status</label>
              <select class="form-select" [(ngModel)]="bookForm.status">
                @for (s of ['Available','Reserved','Damaged','Under Repair']; track s) { <option [value]="s">{{ s }}</option> }
              </select></div>
            <div class="col-12"><label class="form-label fw-semibold">Description</label>
              <textarea class="form-control" [(ngModel)]="bookForm.description" rows="2" maxlength="500" placeholder="Short description of the book…"></textarea></div>
          </div>
          <div class="d-flex justify-content-end gap-3 mt-4">
            <button class="btn btn-outline-secondary px-4" (click)="bookMode.set('list')">Cancel</button>
            <button class="btn lib-btn-primary px-5" (click)="saveBook()"><i class="bi bi-check-circle-fill me-2"></i>{{ editingBookId() !== null ? 'Update' : 'Save' }} Book</button>
          </div>
        </div>
      </div>
    }

    @if (bookMode() === 'detail' && getViewBook()) {
      @let b = getViewBook()!;
      <div class="row g-4">
        <div class="col-lg-4">
          <div class="lib-card">
            <div class="book-detail-cover" [style.background]="'linear-gradient(135deg,' + getCategoryColor(b.category) + ',' + getCategoryColor(b.category) + '55)'">
              <i class="bi bi-book-fill" style="font-size:4rem;color:rgba(255,255,255,.9)"></i>
            </div>
            <div class="lc-body">
              <div class="bc-category mb-1" [style.color]="getCategoryColor(b.category)">{{ b.category }}</div>
              <h5 class="fw-bold mb-1">{{ b.title }}</h5>
              <div class="text-muted small mb-3">{{ b.author }}</div>
              <span class="{{ getBookStatusClass(b.status) }}">{{ b.status }}</span>
              <div class="book-detail-stats mt-3">
                <div class="bds-item"><div class="bds-val">{{ b.copies_total }}</div><div class="bds-label">Total</div></div>
                <div class="bds-div"></div>
                <div class="bds-item"><div class="bds-val text-success">{{ b.copies_available }}</div><div class="bds-label">Available</div></div>
                <div class="bds-div"></div>
                <div class="bds-item"><div class="bds-val text-warning">{{ b.copies_total - b.copies_available }}</div><div class="bds-label">Issued</div></div>
              </div>
              <div class="detail-list mt-3">
                <div class="dl-row"><span>Accession No.</span><span class="font-monospace fw-bold text-primary">{{ b.accession_no }}</span></div>
                @if (b.isbn) { <div class="dl-row"><span>ISBN</span><span>{{ b.isbn }}</span></div> }
                <div class="dl-row"><span>Publisher</span><span>{{ b.publisher }}</span></div>
                <div class="dl-row"><span>Year / Edition</span><span>{{ b.publication_year }} · {{ b.edition }}</span></div>
                @if (b.pages) { <div class="dl-row"><span>Pages</span><span>{{ b.pages }}</span></div> }
                @if (b.price) { <div class="dl-row"><span>Price</span><span class="fw-semibold text-success">{{ formatCurrency(b.price) }}</span></div> }
                <div class="dl-row"><span>Language</span><span>{{ b.language }}</span></div>
                @if (b.shelf_location) { <div class="dl-row"><span>Shelf</span><span class="font-monospace">{{ b.shelf_location }}</span></div> }
              </div>
              <div class="d-flex gap-2 mt-3">
                <button class="btn lib-btn-primary btn-sm w-100" (click)="editBook(b)"><i class="bi bi-pencil-fill me-1"></i>Edit</button>
                <button class="btn btn-outline-danger btn-sm" (click)="confirmDelete('book',b.id,b.title)"><i class="bi bi-trash3"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          @if (b.description) {
            <div class="lib-card mb-3"><div class="lc-header"><i class="bi bi-info-circle-fill me-2"></i>About</div>
              <div class="lc-body"><p class="mb-0 text-secondary" style="line-height:1.7;">{{ b.description }}</p></div></div>
          }
          <div class="lib-card">
            <div class="lc-header"><i class="bi bi-clock-history me-2"></i>Issue History for this Book</div>
            <div class="lc-body p-0">
              @let bookRecs = records().filter(r => r.book_id === b.id);
              @if (bookRecs.length === 0) {
                <div class="p-4 text-center text-muted small">No issue history for this book.</div>
              } @else {
                <table class="lib-table">
                  <thead><tr><th>Member</th><th>Issue Date</th><th>Due Date</th><th>Return Date</th><th>Fine</th><th>Status</th></tr></thead>
                  <tbody>
                    @for (r of bookRecs; track r.id) {
                      <tr>
                        <td><div class="fw-semibold small">{{ r.member_name }}</div><div class="small text-muted">{{ r.member_code }}</div></td>
                        <td class="small">{{ formatDate(r.issue_date) }}</td>
                        <td class="small" [class.text-danger]="isOverdue(r)">{{ formatDate(r.due_date) }}</td>
                        <td class="small text-muted">{{ r.return_date ? formatDate(r.return_date) : '—' }}</td>
                        <td class="small" [class.text-danger]="r.fine_amount > 0 && !r.fine_paid">{{ r.fine_amount > 0 ? formatCurrency(r.fine_amount) : '—' }}</td>
                        <td><span class="{{ getIssueStatusClass(isOverdue(r) ? 'Overdue' : r.status) }}">{{ isOverdue(r) ? 'Overdue' : r.status }}</span></td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          </div>
        </div>
      </div>
    }
  }

  <!-- ===================== ISSUE / RETURN ===================== -->
  @if (activeTab() === 'issue') {
    <!-- Mode Toggle -->
    <div class="issue-toggle mb-4">
      <button class="it-btn" [class.active]="issueMode() === 'issue'" (click)="issueMode.set('issue')">
        <i class="bi bi-arrow-up-circle-fill me-2"></i>Issue Book
      </button>
      <button class="it-btn" [class.active]="issueMode() === 'return'" (click)="issueMode.set('return')">
        <i class="bi bi-arrow-down-circle-fill me-2"></i>Return Book
        @if (overdueIssues().length > 0) { <span class="overdue-badge">{{ overdueIssues().length }} overdue</span> }
      </button>
    </div>

    <!-- ISSUE FORM -->
    @if (issueMode() === 'issue') {
      <div class="row g-4">
        <div class="col-lg-7">
          <div class="lib-card">
            <div class="lc-header"><i class="bi bi-arrow-up-circle-fill me-2"></i>Issue Book to Member</div>
            <div class="lc-body">
              <!-- Member Lookup -->
              <div class="lookup-section mb-4">
                <div class="lookup-label"><i class="bi bi-person-fill me-2 text-primary"></i>Step 1 — Find Member</div>
                <div class="input-group">
                  <input class="form-control" [(ngModel)]="issueForm.member_search" placeholder="Enter Member ID or Name (try LM-S-001, LM-T-001…)" (keyup.enter)="searchMember()">
                  <button class="btn lib-btn-primary" (click)="searchMember()"><i class="bi bi-search me-1"></i>Search</button>
                </div>
                @if (issueSubmitted && !issueForm.selected_member) { <div class="text-danger small mt-1">Please select a valid member.</div> }
              </div>
              @if (issueForm.selected_member) {
                @let m = issueForm.selected_member;
                <div class="member-found-card mb-4">
                  <div class="mfc-avatar" [class.mfc-faculty]="m.member_type==='Faculty'" [class.mfc-staff]="m.member_type==='Staff'">{{ getInitials(m.member_name) }}</div>
                  <div>
                    <div class="mfc-name">{{ m.member_name }}</div>
                    <div class="mfc-meta">{{ m.member_id }} · {{ m.class_dept }} · {{ m.member_type }}</div>
                    <div class="mfc-stats">
                      <span [class.text-warning]="m.active_issues >= m.max_books">{{ m.active_issues }}/{{ m.max_books }} books issued</span>
                      @if (m.fine_pending > 0) { <span class="ms-2 text-danger">Fine: {{ formatCurrency(m.fine_pending) }}</span> }
                    </div>
                  </div>
                  @if (m.active_issues >= m.max_books) {
                    <span class="ms-auto text-danger small fw-bold">Limit Reached</span>
                  }
                </div>
              }

              <!-- Book Lookup -->
              <div class="lookup-section mb-4">
                <div class="lookup-label"><i class="bi bi-book-fill me-2 text-success"></i>Step 2 — Find Book</div>
                <div class="input-group">
                  <input class="form-control" [(ngModel)]="issueForm.book_search" placeholder="Enter Accession No., ISBN or Title (try LIB-001…)" (keyup.enter)="searchBook()">
                  <button class="btn lib-btn-primary" (click)="searchBook()"><i class="bi bi-search me-1"></i>Search</button>
                </div>
                @if (issueSubmitted && !issueForm.selected_book) { <div class="text-danger small mt-1">Please select an available book.</div> }
              </div>
              @if (issueForm.selected_book) {
                @let bk = issueForm.selected_book;
                <div class="book-found-card mb-4">
                  <div class="bfc-icon" [style.background]="getCategoryColor(bk.category)"><i class="bi bi-book-fill"></i></div>
                  <div>
                    <div class="bfc-title">{{ bk.title }}</div>
                    <div class="bfc-meta">{{ bk.author }} · {{ bk.publisher }}</div>
                    <div class="bfc-avail"><span class="text-success fw-semibold">{{ bk.copies_available }} copies available</span> · Shelf: {{ bk.shelf_location }}</div>
                  </div>
                  <div class="ms-auto"><span class="font-monospace small fw-bold text-primary">{{ bk.accession_no }}</span></div>
                </div>
              }

              <!-- Dates -->
              <div class="row g-3 mb-3">
                <div class="col-6"><label class="form-label fw-semibold">Issue Date <span class="req">*</span></label>
                  <input type="date" class="form-control" [(ngModel)]="issueForm.issue_date"></div>
                <div class="col-6"><label class="form-label fw-semibold">Due Date <span class="req">*</span></label>
                  <input type="date" class="form-control" [(ngModel)]="issueForm.due_date"></div>
                <div class="col-12"><label class="form-label fw-semibold">Remarks</label>
                  <input class="form-control" [(ngModel)]="issueForm.remarks" placeholder="Optional notes"></div>
              </div>

              <button class="btn lib-btn-primary w-100 py-3"
                (click)="issueBook()"
                [disabled]="!issueForm.selected_member || !issueForm.selected_book">
                <i class="bi bi-arrow-up-circle-fill me-2 fs-5"></i>
                Issue Book
              </button>
            </div>
          </div>
        </div>
        <!-- Recent Issues -->
        <div class="col-lg-5">
          <div class="lib-card">
            <div class="lc-header"><i class="bi bi-clock-history me-2"></i>Recently Issued</div>
            <div class="lc-body p-0">
              @for (r of records().filter(x => x.status === 'Issued').slice(0,6); track r.id) {
                <div class="recent-row" [class.overdue-row]="isOverdue(r)">
                  <div class="rr-avatar">{{ r.member_name.charAt(0) }}</div>
                  <div>
                    <div class="rr-book">{{ r.book_title }}</div>
                    <div class="rr-member">{{ r.member_name }} · {{ r.member_code }}</div>
                  </div>
                  <div class="rr-right">
                    <div class="small" [class.text-danger]="isOverdue(r)" [class.text-muted]="!isOverdue(r)">
                      Due: {{ formatDate(r.due_date) }}
                    </div>
                    @if (isOverdue(r)) { <span class="overdue-chip-sm">{{ daysOverdue(r) }}d overdue</span> }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- RETURN FORM -->
    @if (issueMode() === 'return') {
      <div class="row g-4">
        <div class="col-lg-8">
          <div class="lib-card mb-3"><div class="lc-body">
            <label class="form-label small fw-semibold text-muted">Search Issued Books</label>
            <div class="input-group">
              <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
              <input class="form-control border-start-0" placeholder="Book title, member name or ID…" [(ngModel)]="returnSearch">
              @if (returnSearch) { <button class="btn btn-outline-secondary" (click)="returnSearch=''"><i class="bi bi-x"></i></button> }
            </div>
          </div></div>

          <div class="lib-card">
            <div class="lc-header"><i class="bi bi-arrow-down-circle-fill me-2"></i>Select Book to Return</div>
            <div class="lc-body p-0">
              @if (returnableRecords().length === 0) {
                <div class="p-4 text-center text-muted small">No issued books found.</div>
              } @else {
                @for (r of returnableRecords(); track r.id) {
                  <div class="return-row" [class.selected-row]="returnForm.selected_record?.id === r.id"
                    [class.overdue-row]="isOverdue(r)"
                    (click)="selectReturn(r)">
                    <div class="rr-check">
                      @if (returnForm.selected_record?.id === r.id) { <i class="bi bi-check-circle-fill text-primary"></i> }
                      @else { <i class="bi bi-circle text-muted"></i> }
                    </div>
                    <div class="return-book-icon" [style.background]="getCategoryColor('Other')"><i class="bi bi-book-fill"></i></div>
                    <div class="flex-fill">
                      <div class="fw-semibold small">{{ r.book_title }} <span class="text-muted">· {{ r.accession_no }}</span></div>
                      <div class="small text-muted">{{ r.member_name }} · {{ r.member_code }} · {{ r.class_dept }}</div>
                      <div class="small">Issued: {{ formatDate(r.issue_date) }} · Due: <span [class.text-danger]="isOverdue(r)">{{ formatDate(r.due_date) }}</span></div>
                    </div>
                    @if (isOverdue(r)) {
                      <div class="text-end">
                        <span class="overdue-chip-sm">{{ daysOverdue(r) }}d overdue</span>
                        <div class="small text-danger fw-bold">{{ formatCurrency(calcFine(r)) }} fine</div>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          @if (returnForm.selected_record) {
            <div class="lib-card">
              <div class="lc-header"><i class="bi bi-receipt-cutoff me-2"></i>Return Details</div>
              <div class="lc-body">
                <div class="return-summary mb-3">
                  <div class="rs-row"><span>Book</span><span class="fw-semibold small">{{ returnForm.selected_record.book_title }}</span></div>
                  <div class="rs-row"><span>Member</span><span class="small">{{ returnForm.selected_record.member_name }}</span></div>
                  <div class="rs-row"><span>Issue Date</span><span class="small">{{ formatDate(returnForm.selected_record.issue_date) }}</span></div>
                  <div class="rs-row"><span>Due Date</span><span class="small" [class.text-danger]="isOverdue(returnForm.selected_record)">{{ formatDate(returnForm.selected_record.due_date) }}</span></div>
                  @if (isOverdue(returnForm.selected_record)) {
                    <div class="rs-row text-danger"><span>Days Overdue</span><span class="fw-bold">{{ daysOverdue(returnForm.selected_record) }} days</span></div>
                  }
                </div>

                <div class="row g-3 mb-3">
                  <div class="col-12"><label class="form-label fw-semibold">Return Date</label>
                    <input type="date" class="form-control" [(ngModel)]="returnForm.return_date"></div>
                  <div class="col-8"><label class="form-label fw-semibold">Fine Amount (₹)</label>
                    <input type="number" class="form-control" [(ngModel)]="returnForm.fine_amount" min="0"></div>
                  <div class="col-4">
                    <label class="form-label fw-semibold">Fine Paid</label>
                    <div class="form-check form-switch mt-2">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="returnForm.fine_paid">
                      <label class="form-check-label small">{{ returnForm.fine_paid ? 'Yes' : 'No' }}</label>
                    </div>
                  </div>
                  <div class="col-12"><label class="form-label fw-semibold">Remarks</label>
                    <input class="form-control" [(ngModel)]="returnForm.remarks" placeholder="Optional notes"></div>
                </div>

                <button class="btn btn-success w-100 py-2 fw-semibold" (click)="returnBook()">
                  <i class="bi bi-arrow-down-circle-fill me-2"></i>Confirm Return
                </button>
              </div>
            </div>
          } @else {
            <div class="lib-card">
              <div class="lc-body text-center py-5">
                <i class="bi bi-arrow-left-circle text-muted" style="font-size:2.5rem;display:block;margin-bottom:12px;"></i>
                <p class="text-muted small">Select a book from the list to process its return.</p>
              </div>
            </div>
          }
        </div>
      </div>
    }
  }

  <!-- ===================== RECORDS ===================== -->
  @if (activeTab() === 'records') {
    <div class="lib-card mb-3"><div class="lc-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-4"><label class="form-label small fw-semibold text-muted">Search</label>
          <div class="input-group"><span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input class="form-control border-start-0" placeholder="Book, member, accession no…" [(ngModel)]="recSearch">
            @if (recSearch) { <button class="btn btn-outline-secondary" (click)="recSearch=''"><i class="bi bi-x"></i></button> }
          </div></div>
        <div class="col-md-2"><label class="form-label small fw-semibold text-muted">Status</label>
          <select class="form-select" [(ngModel)]="recStatus">
            <option value="">All</option>
            @for (s of ['Issued','Returned','Overdue','Lost']; track s) { <option [value]="s">{{ s }}</option> }
          </select></div>
        <div class="col-md-2"><label class="form-label small fw-semibold text-muted">From</label>
          <input type="date" class="form-control" [(ngModel)]="recDateFrom"></div>
        <div class="col-md-2"><label class="form-label small fw-semibold text-muted">To</label>
          <input type="date" class="form-control" [(ngModel)]="recDateTo"></div>
        <div class="col-auto"><button class="btn btn-outline-secondary" (click)="recSearch='';recStatus='';recDateFrom='';recDateTo=''"><i class="bi bi-arrow-counterclockwise me-1"></i>Reset</button></div>
      </div>
      <small class="text-muted mt-2 d-block">{{ filteredRecords().length }} records</small>
    </div></div>

    <div class="lib-card"><div class="lc-body p-0">
      @if (filteredRecords().length === 0) {
        <div class="empty-state"><i class="bi bi-table"></i><p>No records found</p></div>
      } @else {
        <div class="table-responsive">
          <table class="lib-table">
            <thead><tr>
              <th>Book</th><th>Member</th><th>Issue Date</th><th>Due Date</th>
              <th>Return Date</th><th class="text-end">Fine</th><th>Status</th><th class="text-center">Action</th>
            </tr></thead>
            <tbody>
              @for (r of filteredRecords(); track r.id) {
                @let ov = isOverdue(r);
                <tr [class.overdue-tr]="ov">
                  <td>
                    <div class="fw-semibold small">{{ r.book_title }}</div>
                    <div class="small text-muted font-monospace">{{ r.accession_no }}</div>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <div class="rec-avatar">{{ r.member_name.charAt(0) }}</div>
                      <div><div class="fw-semibold small">{{ r.member_name }}</div><div class="small text-muted">{{ r.member_code }}</div></div>
                    </div>
                  </td>
                  <td class="small text-muted">{{ formatDate(r.issue_date) }}</td>
                  <td class="small" [class.text-danger]="ov" [class.fw-bold]="ov">{{ formatDate(r.due_date) }} @if(ov){<span class="overdue-chip-sm ms-1">{{ daysOverdue(r) }}d</span>}</td>
                  <td class="small text-muted">{{ r.return_date ? formatDate(r.return_date) : '—' }}</td>
                  <td class="text-end small" [class.text-danger]="r.fine_amount > 0 && !r.fine_paid" [class.text-success]="r.fine_amount > 0 && r.fine_paid">
                    {{ r.fine_amount > 0 ? formatCurrency(r.fine_amount) : '—' }}
                    @if (r.fine_amount > 0) { <div class="small" [class.text-danger]="!r.fine_paid" [class.text-success]="r.fine_paid">{{ r.fine_paid ? '✓ Paid' : '✗ Pending' }}</div> }
                  </td>
                  <td><span class="{{ getIssueStatusClass(ov ? 'Overdue' : r.status) }}">{{ ov ? 'Overdue' : r.status }}</span></td>
                  <td class="text-center">
                    <button class="lib-del-btn" (click)="confirmDelete('record',r.id,r.book_title)"><i class="bi bi-trash3-fill"></i></button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div></div>
  }

  <!-- ===================== MEMBERS ===================== -->
  @if (activeTab() === 'members') {

    @if (memberMode() === 'list') {
      <div class="lib-card mb-3"><div class="lc-body">
        <div class="input-group" style="max-width:400px">
          <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
          <input class="form-control border-start-0" placeholder="Name, ID, mobile…" [(ngModel)]="memberSearch">
        </div>
      </div></div>

      <div class="members-grid">
        @for (m of filteredMembers(); track m.id) {
          <div class="member-card">
            <div class="mc-top">
              <div class="mc-avatar" [class.mca-faculty]="m.member_type==='Faculty'" [class.mca-staff]="m.member_type==='Staff'">{{ getInitials(m.member_name) }}</div>
              <div class="mc-info">
                <div class="mc-name">{{ m.member_name }}</div>
                <div class="mc-id">{{ m.member_id }}</div>
                <div class="mc-meta">{{ m.member_type }} · {{ m.class_dept }}</div>
              </div>
              <div class="mc-status-dot" [class.dot-active]="m.is_active" [class.dot-inactive]="!m.is_active"></div>
            </div>
            <div class="mc-stats">
              <div class="ms-item"><span class="ms-val" [class.text-warning]="m.active_issues > 0">{{ m.active_issues }}</span><span class="ms-label">Issued</span></div>
              <div class="ms-div"></div>
              <div class="ms-item"><span class="ms-val">{{ m.max_books }}</span><span class="ms-label">Max</span></div>
              <div class="ms-div"></div>
              <div class="ms-item"><span class="ms-val" [class.text-danger]="m.fine_pending > 0">{{ m.fine_pending > 0 ? formatCurrency(m.fine_pending) : '—' }}</span><span class="ms-label">Fine</span></div>
              <div class="ms-div"></div>
              <div class="ms-item d-flex flex-column gap-2">
                <button class="mcf-btn edit" (click)="editMember(m)"><i class="bi bi-pencil-fill me-1"></i>Edit</button>
                <button class="mcf-btn delete" (click)="confirmDelete('member',m.id,m.member_name)"><i class="bi bi-trash3-fill"></i>Del</button>
              </div>
            </div>
            <!-- Issue bar -->
            <!-- <div class="mc-bar-wrap">
              <div class="mc-bar-bg">
                <div class="mc-bar-fill" [style.width.%]="(m.active_issues/m.max_books)*100" [style.background]="m.active_issues >= m.max_books ? '#ef4444' : '#22c55e'"></div>
              </div>
            </div> -->
            <!-- <div class="mc-footer">
              <button class="mcf-btn edit" (click)="editMember(m)"><i class="bi bi-pencil-fill me-1"></i>Edit</button>
              <button class="mcf-btn delete" (click)="confirmDelete('member',m.id,m.member_name)"><i class="bi bi-trash3-fill"></i></button>
            </div> -->
          </div>
        }
        <div class="add-card" (click)="openNewMember()"><i class="bi bi-plus-circle-fill"></i><span>Add Member</span></div>
      </div>
    }

    @if (memberMode() === 'form') {
      <div class="lib-card" style="max-width:700px">
        <div class="lc-header"><i class="bi bi-people-fill me-2"></i>{{ editingMemberId() !== null ? 'Edit Member' : 'Add Library Member' }}</div>
        <div class="lc-body">
          <div class="row g-3">
            <div class="col-md-4"><label class="form-label fw-semibold">Member ID <span class="req">*</span></label>
              <input class="form-control text-uppercase" [(ngModel)]="memberForm.member_id" placeholder="LM-S-006" [class.is-invalid]="memberSubmitted && !memberForm.member_id"></div>
            <div class="col-md-8"><label class="form-label fw-semibold">Full Name <span class="req">*</span></label>
              <input class="form-control" [(ngModel)]="memberForm.member_name" placeholder="Full name" [class.is-invalid]="memberSubmitted && !memberForm.member_name"></div>
            <div class="col-md-4"><label class="form-label fw-semibold">Member Type</label>
              <select class="form-select" [(ngModel)]="memberForm.member_type">@for(t of memberTypes;track t){<option [value]="t">{{ t }}</option>}</select></div>
            <div class="col-md-5"><label class="form-label fw-semibold">Class / Department</label>
              <select class="form-select" [(ngModel)]="memberForm.class_dept">
                <option value="">--</option>@for(c of classOptions;track c){<option [value]="c.code">{{ c.name }}</option>}
              </select></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Max Books</label>
              <input type="number" class="form-control" [(ngModel)]="memberForm.max_books" min="1" max="20"></div>
            <div class="col-md-5"><label class="form-label fw-semibold">Mobile</label>
              <div class="input-group"><span class="input-group-text bg-light">+91</span>
                <input class="form-control" [(ngModel)]="memberForm.mobile" maxlength="10"></div></div>
            <div class="col-md-7"><label class="form-label fw-semibold">Email</label>
              <input type="email" class="form-control" [(ngModel)]="memberForm.email"></div>
            <div class="col-md-4"><label class="form-label fw-semibold">Membership From</label>
              <input type="date" class="form-control" [(ngModel)]="memberForm.membership_from"></div>
            <div class="col-md-4"><label class="form-label fw-semibold">Membership To</label>
              <input type="date" class="form-control" [(ngModel)]="memberForm.membership_to"></div>
            <div class="col-md-4"><label class="form-label fw-semibold">Status</label>
              <select class="form-select" [(ngModel)]="memberForm.is_active">
                <option [value]="true">Active</option><option [value]="false">Inactive</option>
              </select></div>
          </div>
          <div class="d-flex justify-content-end gap-3 mt-4">
            <button class="btn btn-outline-secondary px-4" (click)="memberMode.set('list')">Cancel</button>
            <button class="btn lib-btn-primary px-5" (click)="saveMember()"><i class="bi bi-check-circle-fill me-2"></i>{{ editingMemberId() !== null ? 'Update' : 'Save' }}</button>
          </div>
        </div>
      </div>
    }
  }

</div>
